import React from 'react';
import { Navigate } from 'react-router-dom';
import _ from 'lodash';
import { getItemFromLocalStorage } from '@utils/localStorage';
import { fetchSubDomain } from '@utils/urlHelpers';

export const USER_TYPE_IDS = {
	STAFF: '1',
	STUDENT: '2',
	PARENT: '3',
};

export const HOME_PATH_BY_USER_TYPE = {
	[USER_TYPE_IDS.STAFF]: '/',
	[USER_TYPE_IDS.STUDENT]: '/student',
};

const subDomain = fetchSubDomain();

const UserTypeGate = (props) => {
	const { expectedTypeId, children } = props;

	const userData = getItemFromLocalStorage(subDomain);

	if (_.isNil(userData)) {
		return <Navigate to="/logIn" />;
	}

	const typeId = _.toString(_.get(userData, 'fk_user_type_id'));

	if (typeId !== expectedTypeId) {
		return (
			<Navigate
				to={
					HOME_PATH_BY_USER_TYPE[typeId] ??
					HOME_PATH_BY_USER_TYPE[USER_TYPE_IDS.STAFF]
				}
			/>
		);
	}

	return children;
};

export default UserTypeGate;
